// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M11 2H2V22H11V2Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M13 22H22V13H13V22Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 11V2H13V11H22Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-module-filled')
export default class ModuleFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'module-filled',
    }
  }
}
